// @flow
import * as React from 'react';
import moment from 'moment';

interface WeekdayProps {
  className: string;
  locale: string;
  localeUtils: Object;
  weekday: number;
}

export default function Weekday(props: WeekdayProps) {
  const title = props.localeUtils.formatWeekdayLong(props.weekday, props.locale);
  const abbr = moment().day(props.weekday).format('ddd');
  return (
    <div className={props.className} role="columnheader">
      <abbr title={title}>{abbr}</abbr>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/inner/WeekDay.js